import ReactModal from "react-modal";
import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";
import axios from "axios";
import Cookies from "universal-cookie";
import { MorbilidadPorInstitucion, MorbilidadTodos } from "../../Services/Rest";
import React, { useMemo, useState, useEffect } from "react";
import MaterialReactTable from "material-react-table";

const urlA = MorbilidadTodos;
const urlU = MorbilidadPorInstitucion;
const cookie = new Cookies();

if (cookie.get("tipo_Usuario") == 1) {
  var urlendpoint = urlA;
}
if (cookie.get("tipo_Usuario") == 2) {
  var urlendpoint =
    "https://suadesarrollo.azurewebsites.net/api/ObtenerQIndicadoresMorbilidadPorInstitucionIdAno?InstitucionId=" +
    cookie.get("institucionid") +
    "&Ano=" +
    new Date().getFullYear();
}
if (cookie.get("tipo_Usuario") == 3) {
  var urlendpoint = urlA;
}
if (cookie.get("tipo_Usuario") == 4) var urlendpoint = urlA;

const InfoMorbilidad = () => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        filterVariant: "text", // default
      },
      {
        accessorKey: "grupo",
        header: "Grupo",
        filterVariant: "text",
      },
      {
        accessorKey: "ano",
        header: "Año",
        filterVariant: "range",
        filterFn: "betweenInclusive", // default
      },
      {
        accessorKey: "consecutivo",
        header: "Consecutivo",
        filterVariant: "text",
      },
      {
        accessorKey: "causa",
        header: "Causa",
        filterVariant: "text",
      },
      {
        accessorKey: "estado",
        header: "Estado",
        filterVariant: "text",
      },
      {
        accessorKey: "datoMasculino",
        header: "Dato Masculino",
        filterVariant: "text",
      },
      {
        accessorKey: "proporcionMasculino",
        header: "Proporción Masculino",
        filterVariant: "text",
      },
      {
        accessorKey: "datoFemenino",
        header: "Dato Femenino",
        filterVariant: "text",
      },
      {
        accessorKey: "proporcionFemenino",
        header: "Proporción Femenino",
        filterVariant: "text",
      },
      {
        accessorKey: "total",
        header: "Total",
        filterVariant: "text",
      },
      {
        accessorKey: "proporcionTotal",
        header: "Proporción Total",
        filterVariant: "text",
      },
      {
        accessorKey: "nombreInstitucion",
        header: "nombreInstitucion",
        filterVariant: "text",
        // use betweenInclusive instead of between
      },
    ],
    [],
  );
  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: urlendpoint,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);
  return (
    <div>
      <button
        variant="contained"
        className="btn btn-primary"
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Información de los indicadores
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Info Morbilidad"
      >
        <MaterialReactTable
          columns={columns}
          data={list1}
          initialState={{ showColumnFilters: true }}
        />
      </ReactModal>
    </div>
  );
};

export default InfoMorbilidad;
